import axios from "axios";

import config from "./config";

export default class AutService {
  static async auth(carteira, dataNascimento) {
    const bodyFormData = new FormData();
    bodyFormData.append("servico", "autenticarUsr");
    bodyFormData.append("codusu", carteira);
    bodyFormData.append("dtnas", dataNascimento);
    let response = "";
    try {
      response = await axios.post(config.API_URL_BASE, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    } catch (err) {
        return {status: false, error:err};
    }
    return response.data
  }

  
  static async getMatriculaVida(carteira) {
    

    try {
      const response = await axios.get(`${config.API_CLIENTE_DIGITAL + '/matriculaVida'}`, {
        headers: {
          "client_id_secret": config.API_TOKEN_SENSEDIA,
          "chave": carteira
        }
      });
      return response.data;
    } catch (err) {
      return { status: false, error: err };
    }
  }

  static async createIntercambioProtheus(carteira, nome, dataNascimento, cpf, sexo) {
    const data = { 
      carteirinha: carteira,
      nome: nome.toUpperCase() || "Nome Padrão",
      dataNascimento,
      cpf: cpf.replace(/[.-]/g, ""),
      matvida: "",
      sexo: sexo === 'M' ? '1' : '2'

    }
    // try {
    //   const response = await axios.post(config.API_REST_PROTHEUS+'/RF00024/criar', data, {
    //     headers: {
    //       "Content-Type": "application/json"
    //     }
    //   });
    //   return response.data;
    // } catch (err) {
    //   console.error('Error creating record:', err.response ? err.response.data : err.message);
    //   return { status: false, error: err };
    // }
    try {
      const response = await axios.post(config.API_CLIENTE_DIGITAL +'/criarGuia' ,data, {
          headers: {
              'client_id_secret': config.API_TOKEN_SENSEDIA,
          }
      });
        return response.data;
      } catch (err) {
          console.error('Error creating record:', err.response ? err.response.data : err.message);
          return { status: false, error: err };
      }
  }

}
